import { styled, Box } from "@mui/material";

const AppLayout = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

export default AppLayout;
